import { z } from 'zod';

export type DeliveryPrice = {
    id: number,
    brand_id?: number,
    brand_name?: string,
    model_id?: number,
    model_name?: string,
    city_from_id?: number,
    city_from_name?: string,
    city_to_id?: number,
    city_to_name?: string,
    price: number,
    estimated_days: number,
    is_active?: boolean,
    updated_at?: string,
};

export const DeliveryPriceSchema = z.object({
    id: z.number(),
    brand_id: z.number().optional(),
    brand_name: z.string().optional(),
    model_id: z.number().optional(),
    model_name: z.string().optional(),
    city_from_id: z.number().optional(),
    city_from_name: z.string().optional(),
    city_to_id: z.number().optional(),
    city_to_name: z.string().optional(),
    price: z.number(),
    estimated_days: z.number(),
    is_active: z.boolean().optional(),
    updated_at: z.string().optional(),
});
